import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";

const images = [
  {
    src: "/abhyant-photo.png",
    alt: "Advocate Abhyant Patel",
  },
  {
    src: "/rupam-photo.png",
    alt: "Advocate Rupam Kumari",
  },
];

const TrustSection = () => {
  const [current, setCurrent] = useState(0);

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-16 md:py-24" style={{ backgroundColor: "#111111" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
              A Team That You Can Trust
            </h2>
            <p className="text-lg leading-relaxed" style={{ color: "#999999" }}>
              With experience before multiple High Courts and District Courts
              across India, NamoriSatya Legal provides dedicated, result-focused
              legal representation. Every case receives personalized attention
              and a strong legal strategy.
            </p>
            <p className="text-lg leading-relaxed" style={{ color: "#999999" }}>
              Our advocates are committed to protecting your rights and ensuring
              justice through every step of the legal process.
            </p>
            <Button
              onClick={scrollToContact}
              className="text-base font-semibold px-8 py-6 transition-all duration-300 hover:opacity-90 group"
              style={{ backgroundColor: "#2B2BFF", color: "white" }}
            >
              We offer free initial consultation for all new clients
              <ArrowRight className="ml-2 h-5 w-5 inline-block group-hover:translate-x-1 transition-transform" />
            </Button>
          </motion.div>

          {/* Right Column - Auto Sliding Images */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative rounded-lg overflow-hidden shadow-2xl"
            style={{ height: "600px" }}
          >
            <AnimatePresence mode="wait">
              <motion.img
                key={current}
                src={images[current].src}
                alt={images[current].alt}
                initial={{ x: "100%", opacity: 0 }}
                animate={{ x: "0%", opacity: 1 }}
                exit={{ x: "-100%", opacity: 0 }}
                transition={{ duration: 0.8, ease: "easeInOut" }}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </AnimatePresence>

            {/* Dots indicator */}
            <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-2 z-10">
              {images.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className="w-3 h-3 rounded-full transition-all duration-300"
                  style={{
                    backgroundColor:
                      i === current ? "#2B2BFF" : "rgba(255,255,255,0.5)",
                    transform: i === current ? "scale(1.3)" : "scale(1)",
                  }}
                />
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
